import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadProducts = create(actions.LOAD_PRODUCTS_DATA);
export const setProductsStatus = create(actions.SET_PRODUCTS_STATUS);
export const setProductsData = create(actions.SET_PRODUCTS_DATA);

export const loadItemComments = create(actions.LOAD_ITEM_COMMENTS_DATA);
export const setItemCommentsStatus = create(actions.SET_ITEM_COMMENTS_STATUS);
export const setItemCommentsData = create(actions.SET_ITEM_COMMENTS_DATA);

export const loadCategoryComments = create(actions.LOAD_CATEGORY_COMMENTS_DATA);
export const setCategoryCommentsStatus = create(actions.SET_CATEGORY_COMMENTS_STATUS);
export const setCategoryCommentsData = create(actions.SET_CATEGORY_COMMENTS_DATA);

export const setIsStockOrder = create(actions.SET_IS_STOCK_ORDER);
